import React from 'react';
import PropTypes from 'prop-types';
import { ModalButton } from 'models/utils/common/modal-button-model';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/common/modal-component';
import ProjectListEntry from 'models/data/project-list-entry-model';

const PERMANENT_DELETE_PROJECT_ID_BLOCK = 'project-card-id';

const PermanentDeleteModal = ({
  togglePermanentDeleteModal,
  permanentDeleteAction,
  project,
  updateFilteredProjectList,
}) => {
  return (
    <Modal
      id={`${PERMANENT_DELETE_PROJECT_ID_BLOCK}__permanent-delete-modal`}
      title={'project-list.delete-modal.title'}
      onClose={togglePermanentDeleteModal}
      primaryModalButton={
        new ModalButton({
          text: 'common.yes',
          onClick: async () => {
            togglePermanentDeleteModal();
            await permanentDeleteAction({ project });
            updateFilteredProjectList();
          },
        })
      }
      secondaryModalButton={
        new ModalButton({
          text: 'common.no',
          onClick: togglePermanentDeleteModal,
        })
      }
    >
      <div className="modal__text">
        <FormattedMessage id="project-list.permanent-delete-modal.message" />
      </div>
    </Modal>
  );
};

PermanentDeleteModal.propTypes = {
  /** Method on the project list card component to show permanent delete modal */
  togglePermanentDeleteModal: PropTypes.func.isRequired,
  /** Function that governs the behavior when the permanent delete option is clicked on the project card component */
  permanentDeleteAction: PropTypes.func.isRequired,
  /** Project to be permanently deleted */
  project: PropTypes.instanceOf(ProjectListEntry).isRequired,
  /** function fired to update project list with latest project data */
  updateFilteredProjectList: PropTypes.func.isRequired,
};

export default PermanentDeleteModal;
